import { InputAdornment, InputBaseProps, SlotProps, TextFieldOwnerState } from "@mui/material";
import { Icon, Maybe } from "../../resolvers-types";
import NGIcon from "../components/NGIcon/NGIcon";
import { RuntimeContext } from "./NGFieldExtensions";

export const setAdornment = ({
  position,
  adornment,
  inputProps,
  context,
  configId
}: {
  position: "start" | "end";
  adornment: Maybe<Icon> | undefined;
  inputProps: SlotProps<React.ElementType<InputBaseProps>, object, TextFieldOwnerState>;
  context: RuntimeContext;
  configId: string;
}) => {
  if (adornment) {
    adornment.ContextId = configId;
    adornment.Id = `${configId}_StartIcon`;
    inputProps[`${position}Adornment`] = (
      <InputAdornment position={position}>
        <NGIcon config={adornment} context={context} />
      </InputAdornment>
    );
  }
} 